import { EmojiItem } from '../emoji'
import { removeVariationSelector } from './removeVariationSelector'

export function emojiToShortcode(emoji: string, emojis: EmojiItem[]): string | undefined {
  return emojis.find(item => item.emoji === removeVariationSelector(emoji))?.shortcodes[0]
}
